import { SVGProps } from 'react'

export const Person = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8 8a2.666 2.666 0 100-5.333A2.666 2.666 0 108 8zm0 1.334c-1.78 0-5.333.893-5.333 2.666v1.334h10.666V12c0-1.773-3.553-2.666-5.333-2.666z"
    ></path>
  </svg>
)
